import React, {createContext, useContext, useReducer} from "react";

const DraftContext = createContext();

const initialState = {
  title: "",
  images: {},
};

const reducer = (state, action) => {
  switch (action.type) {
    case "reset":
      return initialState;
    case "set":
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

function DraftContextProvider(props) {
  let [draft, draftDispatch] = useReducer(reducer, initialState);

  const setDraft = payload => draftDispatch({type: "set", payload});

  const value = {draft, draftDispatch, setDraft};

  return <DraftContext.Provider value={value}>{props.children}</DraftContext.Provider>;
}

const useDraft = () => useContext(DraftContext);

export {useDraft, DraftContext, DraftContextProvider};
